import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.136 6.783a.978.978 0 1 0-1.383 1.383l3.92 3.92-3.92 3.92a.978.978 0 1 0 1.383 1.383l3.92-3.92 3.92 3.92a.978.978 0 1 0 1.383-1.383l-3.92-3.92 3.92-3.92a.978.978 0 1 0-1.383-1.383l-3.92 3.92-3.92-3.92Z"
	})
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
